// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/liability-insurance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/liability-insurance/liability-insurance.js';
import g1 from '../lessons/air-law/liability-insurance/passenger-liability-and-operators.js';

mount([g0, g1]);
